import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "../../../../dialogs/StandardDialog"

const useStyles = makeStyles()((theme) => ({
    dialogPaper: {
        "& h4": {
            fontSize: "1.75rem",
            padding: "0 2rem",
        },
    },
    container: {
        padding: "0 2rem 3rem",
        textAlign: "center",
        color: theme.palette.tailwind.slate[900],
    },
}))

type BookPeriodMessageDialogProps = Readonly<{
    onClose: () => void
}>

export function BookPeriodMessageDialog({ onClose }: BookPeriodMessageDialogProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="create-order-book-period-message-dialog-title" attrs={{ dialogTitle: true }}>
            <StandardDialog
                open
                onClose={onClose}
                dialogTitle="To book resources, please click on the resources from the left panel"
                slotProps={{ paper: { className: classes.dialogPaper } }}
            >
                <Stack gap="1rem" className={classes.container}>
                    <LocalizedStrict id="create-order-book-period-message-dialog-note">
                        <Typography variant="body1">
                            The selected resource is not available for the full period
                        </Typography>
                    </LocalizedStrict>
                </Stack>
            </StandardDialog>
        </LocalizedStrict>
    )
}
